/**
 * Inline message for a failed POST /picks. The pick slip keeps its selections
 * in every failure case, so the user can remove the offending pick or retry.
 */
export const PICK_UNEXPECTED_ERROR =
  "An unexpected error occurred. Please try again. If the issue continues, contact support.";
export const PICK_SESSION_EXPIRED =
  "Your session has expired. Please sign in again, then resubmit your picks.";
export const PICK_PROFILE_UNAVAILABLE =
  "We couldn't load your account. Please refresh the page and try again.";

export function pickErrorMessage(
  res: { code?: number; message?: string } | null | undefined
): string {
  if (!res) return PICK_UNEXPECTED_ERROR;
  const code = Number(res.code);
  // The token was rejected (expired session, or an edge/auth layer in front of
  // the API): a retry with the same token cannot succeed.
  if (code === 401 || code === 403) return PICK_SESSION_EXPIRED;
  const message = typeof res.message === "string" ? res.message.trim() : "";
  // Other 4xx carry a user-facing reason from the API: 409 odds unavailable,
  // 409 game already started, 409 duplicate/opposing pick, 404 no odds, 400.
  if (code >= 400 && code < 500 && message) return message;
  // 5xx (internal messages are not shown), network failures, no usable body.
  return PICK_UNEXPECTED_ERROR;
}
